import { getTenantConfig } from "features/white-labeling/lib/tenantConfig";

const leaftechWebsiteUrl = process.env.REACT_APP_LEAFTECH_WEBSITE_URL;

const getViewerUrl = () => getTenantConfig()?.viewerUrl;
const getClientWebsiteUrl = () => getTenantConfig()?.websiteUrl;

export default {
  get clientWebsite() {
    return getClientWebsiteUrl();
  },
  leaftechWebsite: leaftechWebsiteUrl,
  threeDViewer: (projectId, token) => `${getViewerUrl()}/projects/?token=${token}&project_id=${projectId}`,
};
